import dayjs from 'dayjs';
import React from 'react';
import styled from 'styled-components';

import Divider from '@/components/atom/Divider';
import theme from '@/styles/theme';
import { getCurrencyFormat } from '@/utils/format';

interface Props {
  paidAt: number;
  cardName: string;
  cardNumber: string;
  price: number;
  discountPrice: number;
  pointUsed: number;
  paidAmount: number;
}

const QuestionPaymentInfo = ({ paidAt, cardName, cardNumber, price, pointUsed, paidAmount, discountPrice }: Props) => {
  return (
    <>
      <Box>
        <Title>의료진 상담 결제 정보</Title>
        <Receipt>
          <ReceiptContent>
            <ReceiptContentRow>
              <ReceiptContentRowKey>결제일</ReceiptContentRowKey>
              <ReceiptContentRowValue>{dayjs(paidAt).format('YYYY년 M월 D일 (dd)')}</ReceiptContentRowValue>
            </ReceiptContentRow>
            {cardName && cardNumber && (
              <ReceiptContentRow>
                <ReceiptContentRowKey>결제방법</ReceiptContentRowKey>
                <ReceiptContentRowValue>
                  <p>{cardName}</p>
                  <p>{cardNumber}</p>
                </ReceiptContentRowValue>
              </ReceiptContentRow>
            )}
            <ReceiptContentRow>
              <ReceiptContentRowKey>의료진 상담</ReceiptContentRowKey>
              <ReceiptContentRowValue>{getCurrencyFormat(price)}원</ReceiptContentRowValue>
            </ReceiptContentRow>
            <ReceiptContentRow>
              <ReceiptContentRowKey>할인금액</ReceiptContentRowKey>
              <ReceiptContentRowValue>{pointUsed ? `-${getCurrencyFormat(pointUsed)}` : 0}원</ReceiptContentRowValue>
            </ReceiptContentRow>
            <ReceiptContentRow>
              <ReceiptContentRowKey>포인트 사용</ReceiptContentRowKey>
              <ReceiptContentRowValue>{`-${getCurrencyFormat(discountPrice)}`}원</ReceiptContentRowValue>
            </ReceiptContentRow>
          </ReceiptContent>
          <ReceiptResult>
            <ReceiptResultRow>
              <ReceiptResultRowKey>총 결제</ReceiptResultRowKey>
              <ReceiptResultRowValue>{getCurrencyFormat(paidAmount)}원</ReceiptResultRowValue>
            </ReceiptResultRow>
          </ReceiptResult>
        </Receipt>
      </Box>
      <Divider height={'15px'} color={theme.color.gray30} />
    </>
  );
};

export default QuestionPaymentInfo;

const Box = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

const Title = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  ${({ theme }) => `
    background: ${theme.color.white};
    ${theme.typography.UI19SB};
    color:${theme.color.gray900};
  `}
`;

const Receipt = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const ReceiptContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding-bottom: 16px;
  margin-bottom: 16px;

  border-bottom: 1px dashed ${({ theme }) => theme.color.gray50};
`;

const ReceiptContentRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const ReceiptContentRowKey = styled.div`
  ${({ theme }) => `
      ${theme.typography.UI14R};
      color: ${theme.color.gray500};
    `}
`;
const ReceiptContentRowValue = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  ${({ theme }) => `
      ${theme.typography.UI18R};
      color: ${theme.color.gray800};
    `}
`;

const ReceiptResult = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const ReceiptResultRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const ReceiptResultRowKey = styled.div`
  ${({ theme }) => `
      ${theme.typography.UI14R};
      color: ${theme.color.gray500};
    `}
`;
const ReceiptResultRowValue = styled.div`
  ${({ theme }) => `
      ${theme.typography.UI20B};
      color: ${theme.color.blue500};
    `}
`;
